import { styled } from "@mui/material/styles";
import { Button } from "components/button";

export const Component = styled(Button, {
  label: "icon-button",
})`
  padding: 0;
  align-items: center;
`;
